import { render, staticRenderFns } from "./migrationCheck.vue?vue&type=template&id=56685d63&scoped=true&"
import script from "./migrationCheck.vue?vue&type=script&lang=js&"
export * from "./migrationCheck.vue?vue&type=script&lang=js&"
import style0 from "./migrationCheck.vue?vue&type=style&index=0&id=56685d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56685d63",
  null
  
)

export default component.exports